/*=============================================== SearchResults ===============================================*/

import { useSearchParams, Navigate } from "react-router-dom"
import Fuse from "fuse.js"
import { Text, Grid, Button, unslugify, slugify } from "tsx-library-julseb"

import { Page } from "components"

import { allPages } from "data"
import type { PageType } from "data/types"
import { fuseOptions } from "config"

const SearchResults = () => {
    const [searchParams] = useSearchParams()

    const query = searchParams.get("query") || ""

    const fuse = new Fuse<PageType>(allPages, {
        keys: ["title", "category"],
        ...fuseOptions,
    })
    const results = fuse.search<PageType>(query)

    const findPerfectMatch = results.find(
        result => slugify(result.item.title) === slugify(query)
    )

    if (results.length === 1) {
        const url = `/${slugify(results[0].item.category)}/${slugify(
            results[0].item.title
        )}`

        return <Navigate to={url} />
    } else if (findPerfectMatch !== undefined) {
        const match = findPerfectMatch.item
        const url = `/${slugify(match.category)}/${slugify(match.title)}`

        return <Navigate to={url} />
    }

    const pageTitle = `Results for ${query}`

    return (
        <Page title={pageTitle}>
            <Text tag="h1">{pageTitle}</Text>

            {results?.length > 0 ? (
                <Grid col={3} gap="s">
                    {results?.map(({ item }) => {
                        const { category, title } = item

                        return (
                            <Button
                                to={`/${slugify(category)}/${slugify(title)}`}
                                key={title}
                            >
                                {unslugify(title)}
                            </Button>
                        )
                    })}
                </Grid>
            ) : (
                <Text>Your search did not return any result.</Text>
            )}
        </Page>
    )
}

export default SearchResults
